import styled from 'styled-components';
import { MdOutlineVideocamOff } from 'react-icons/md';

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background-color: ${props => props.theme.colors.danger500};
  max-width: 400px;
  margin: 0 auto;
  padding: 24px 16px;
  box-sizing: border-box;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  gap: 36px;
  text-align: center;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  text-align: center;
`;

export const VideoCamOffIcon = styled(MdOutlineVideocamOff).attrs(
  ({ theme }) => ({
    color: theme.colors.white,
    size: 78,
  }),
)``;

export const Title = styled.h1`
  font-weight: 700;
  font-size: 26px;
  line-height: 30px;
  color: ${props => props.theme.colors.white};
  margin: 0;
`;

export const Description = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: ${props => props.theme.colors.white};
  margin: 0;
  text-align: center;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
`;

export const Button = styled.button`
  width: 100%;
  padding: 16px 24px;
  border-radius: 8px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;

  ${({ variant, theme }) =>
    variant === 'contained'
      ? `
    background-color: ${theme.colors.white};
    color: ${theme.colors.danger500};
    border: none;
  `
      : `
    background-color: transparent;
    color: ${theme.colors.white};
    border: none;
  `}

  &:hover {
    opacity: 0.9;
  }
`;
